// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.languages__correction-checkbox .sk-checkbox__input:checked + .sk-checkbox__imitation {\n  border: 1px solid #000 !important;\n  background-color: #000 !important;\n}\n.languages__correction-checkbox .sk-checkbox__imitation {\n  border: 1px solid #a4a9bc !important;\n}\n", ""]);
// Exports
module.exports = exports;
